import { render, staticRenderFns } from "./HelloWidgetTemplate.vue?vue&type=template&id=6c702fe7&scoped=true&lang=pug"
import script from "./HelloWidgetTemplate.vue?vue&type=script&lang=ts"
export * from "./HelloWidgetTemplate.vue?vue&type=script&lang=ts"
import style0 from "./HelloWidgetTemplate.vue?vue&type=style&index=0&id=6c702fe7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c702fe7",
  null
  
)

/* custom blocks */
import block0 from "./HelloWidgetTemplate.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FTemplates%2FHelloWidgetTemplate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports